<template>
  <div class="btn-wrap">
    <div
      v-if="viewModel.isShowBtn"
      @click="handleNotionBtnClick"
      class="webkit-no-drag bell-btn"
    >
      <em v-if="viewModel.isShowRedDot" />
    </div>

    <!-- 消息面板 -->
    <HModal
      :visible="viewModel.visible"
      :closeOnClickMask="false"
      :showClose="false"
    >
      <div class="modal-content">
        <div class="modal-header">
          <i class="logo" />
          <div class="title">
            消息中心
          </div>
          <div
            @click="handleClose"
            class="close-btn"
          />
        </div>
        <div
          v-if="viewModel.dataList.length"
          class="list-content"
        >
          <div
            v-for="item of viewModel.dataList"
            :key="item.msg_id"
            class="list-item"
          >
            <div class="tip-title">
              {{ item.msg_title }}
            </div>
            <div
              @click="handleContentClick"
              v-html="item.msg_content"
              class="tip-detailed"
            />
            <div
              @click="delItem(item.msg_id)"
              class="del-item"
            />
          </div>
        </div>
        <div
          v-else
          class="empty-tip"
        >
          <div class="picture" />
          <div class="text">
            没有任何消息
          </div>
        </div>
      </div>
    </HModal>
  </div>
</template>
<script>
import { defineComponent, reactive, onMounted, watch, computed } from '@vue/composition-api'
import { fetchCursor, deleteHistoryItem, fetchHistoryList, fetchTotalCount, getLastMsgId, setLastMsgId } from '../../api/deduction'
import client from '@/client/'

export default defineComponent({
  setup (props, context) {
    // 用户登录状态
    const loginStatus = computed(() => context.root.$store.state.user.loginStatus)
    const viewModel = reactive({
      isShowBtn: false, // 消息按钮是否展示
      isShowRedDot: false, // 消息红点是否展示
      visible: false, // 消息面板是否展示
      dataList: [], // 消息面板列表
    })

    // 消息面板的展示与隐藏
    const switchModal = () => {
      viewModel.visible = !viewModel.visible
    }

    // 初始化消息红点
    const _initShowingRedDot = async () => {
      // 获取用户最后阅读的游标ID
      const cursor = await getLastMsgId() || '0'
      // 获取游标后的信息数（未读消息）
      const res = await fetchCursor(cursor)
      viewModel.isShowRedDot = res.msg_count > 0
    }

    // 获取消息列表
    const setListData = async () => {
      if (!loginStatus.value) {
        return
      }

      try {
        const res = await fetchHistoryList()
        viewModel.dataList = res.data || []
        if (res.data.length) {
          const firstItem = res.data[0]
          // 设置用户最后阅读的游标
          setLastMsgId(firstItem.msg_id)
        }
      } catch (error) {
        console.error('setListData err', error)
      }
    }

    // 删除续费通知消息
    const delItem = async (id) => {
      client.notion.REPORT.reportMessageCenterOperate({ clicks: 2 })

      // 删除指定消息
      await deleteHistoryItem(id)
      setListData()
    }

    // 初始化消息按钮
    const _initVisible = async () => {
      // 获取消息总数
      const res = await fetchTotalCount()
      // 显示消息按钮规则：消息数总数大于0
      if (res.msg_count > 0) {
        viewModel.isShowBtn = true
      }
    }

    // 处理对应的消息内容点击
    const handleContentClick = (event) => {
      client.notion.REPORT.reportMessageCenterOperate({
        clicks: 3
      })
      const url = event.target?.dataset?.href
      if (url) {
        window.open(url)
      }
    }

    // 消息按钮点击
    const handleNotionBtnClick = () => {
      client.home.REPORT.reportHomeOperate({ main_click: 250 })
      switchModal()
    }

    // 消息面板隐藏
    const handleClose = () => {
      client.notion.REPORT.reportMessageCenterOperate({ clicks: 1 })
      switchModal()
    }

    onMounted(() => {
      if (loginStatus.value) {
        _initVisible()
        _initShowingRedDot()
      }
    })

    watch(() => viewModel.visible,
      newVal => {
        if (newVal) {
          // 当打开消息面板是，红色点消失
          viewModel.isShowRedDot = false
          setListData()
          client.notion.REPORT.reportMessageCenterShow({})
        }
      }
    )
    return {
      viewModel,
      handleClose,
      handleNotionBtnClick,
      delItem,
      handleContentClick
    }
  }
})
</script>
<style lang="scss" scoped>
.btn-wrap {
  display: inline-block;
}

.bell-btn {
  position: relative;
  display: inline-block;
  width: 14px;
  height: 14px;
  margin: 3px 8px 0 0;
  vertical-align: middle;

  background: url('../_img/icon_small_bell.png') no-repeat;
  background-size: contain;
  cursor: pointer;

  em {
    position: absolute;
    top: -2px;
    right: -1px;
    width: 6px;
    height: 6px;
    background: #f20d38;
    border-radius: 50%;
  }
}

.modal-content {
  position: relative;
  width: 680px;
  height: 480px;
}

.modal-header {
  box-sizing: border-box;
  width: 100%;
  height: 28px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  background: #fdd549;
  font-size: 12px;
  color: #b07400;

  .logo {
    width: 13px;
    height: 14px;
    margin-right: 5px;
    display: inline-block;
    background: url('../_img/icon_small_bell.png') no-repeat;
    background-size: cover;
  }
}

.list-content {
  height: 400px;
  padding: 20px;
  font-size: 14px;
  line-height: 24px;
  color: #333333;
  overflow-y: scroll;
  overflow-x: hidden;

  .list-item {
    position: relative;
    padding: 16px;
    border-bottom: 1px solid #e8e8e8;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;

    .del-item {
      display: none;
      position: absolute;
      right: 8px;
      top: 8px;
      width: 14px;
      height: 14px;
      background: url('../_img/small_close_btns.png') no-repeat;
      background-position: 0 0;
      cursor: pointer;

      &:hover {
        background-position: -14px 0;
      }

      &:active {
        background-position: -28px 0;
      }
    }

    &:hover {
      .del-item {
        display: block;
      }

      background: #fffae9;
    }
  }
}

.close-btn {
  position: absolute;
  top: 3px;
  right: 6px;
  width: 24px;
  height: 24px;
  background: url('../_img/close_btns.png') no-repeat;
  background-position: 0 0;
  cursor: pointer;

  &:hover {
    background-position: -24px 0;
  }

  &:active {
    background-position: -48px 0;
  }
}

.empty-tip {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 110px;
  height: 144px;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #888888;

  .picture {
    width: 110px;
    height: 110px;
    background: url('../_img/empty.png') no-repeat;
  }

  .text {
    margin-top: 8px;
    text-indent: -10px;
  }
}

.tip-detailed ::v-deep a {
  color: blue;
  text-decoration: underline;
}
</style>
